import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle, RefreshCw } from "lucide-react";
import { ExpandableTraceTable } from "../CodeGen/Chat/components/traces/ExpandableTraceTable";
import type { EnhancedTrace } from "../CodeGen/Chat/components/traces/types";

interface McpRequestTracesProps {
  projectId: string;
  traces: EnhancedTrace[];
  isLoading?: boolean;
  error?: Error | null;
  className?: string;
  showTimeFilter?: boolean;
  initialExpandedTraceId?: string;
}

export function McpRequestTraces({
  projectId: _projectId,
  traces,
  isLoading = false,
  error = null,
  className = "",
  showTimeFilter: _showTimeFilter = true,
  initialExpandedTraceId,
}: McpRequestTracesProps) {
  return (
    <Card className={className}>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-lg">MCP Request Traces</CardTitle>
        <div className="text-xs text-muted-foreground">
          {traces.length} trace{traces.length !== 1 ? "s" : ""}
        </div>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex items-center justify-center h-32">
            <div className="flex items-center gap-2 text-muted-foreground">
              <RefreshCw className="w-4 h-4 animate-spin" />
              Loading traces...
            </div>
          </div>
        ) : error ? (
          <div className="flex items-center justify-center h-32">
            <div className="flex items-center gap-2 text-destructive">
              <AlertCircle className="w-4 h-4" />
              Error loading traces: {error.message}
            </div>
          </div>
        ) : (
          <ExpandableTraceTable
            traces={traces}
            initialExpandedTraceId={initialExpandedTraceId}
            showInspectorNavigation={true}
            projectId={_projectId}
          />
        )}
      </CardContent>
    </Card>
  );
}
